import { external } from './instances';

const loadApplicationConfig = () => external.get(`/application.json`).then(response => response.data);

export { loadApplicationConfig };
